import { Component, Show, onMount } from 'solid-js'
import { useNavigate } from '@solidjs/router'
import AvatarIcon from '../../shared/AvatarIcon'
import Button from '../../shared/Button'
import { userStore } from '../../store'
import { Page } from '/web/Layout'
import { Edit, MessageSquare, LogOut } from 'lucide-solid'

const ProfileCenter: Component = () => {
  const nav = useNavigate()
  const state = userStore((s) => ({ profile: s.profile, user: s.user }))

  onMount(() => {
    userStore.getProfile()
    userStore.getConfig()
  })

  const handleEditProfile = () => {
    nav('/profile/settings')
  }

  const handleFeedback = () => {
    nav('/profile/feedback')
  }

  const handleLogout = () => {
    userStore.logout()
    nav('/')
  }

  return (
    <Page>
      <div class="flex flex-col items-center justify-center min-h-[80vh] px-4">
        <div class="w-full max-w-md bg-[var(--bg-800)] rounded-lg border border-[var(--hl-500)] p-6">
          {/* Avatar Section */}
          <div class="flex flex-col items-center mb-6">
            <div class="relative">
              <Show
                when={state.profile?.avatar}
                fallback={
                  <div class="w-24 h-24 rounded-full bg-[var(--bg-700)] flex items-center justify-center border-2 border-[var(--hl-500)]">
                    <svg
                      class="w-12 h-12 text-[var(--text-500)]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                }
              >
                <AvatarIcon
                  avatarUrl={state.profile?.avatar}
                  format={{ size: 'lg', corners: 'circle' }}
                  class="w-24 h-24"
                />
              </Show>
              {/* Online Status Indicator */}
              <div class="absolute bottom-0 right-0 w-4 h-4 bg-green-500 rounded-full border-2 border-[var(--bg-800)]"></div>
            </div>

            {/* User Name */}
            <div class="mt-4 text-2xl font-bold text-white">
              {state.profile?.handle || state.user?.username || 'User'}
            </div>

            {/* Email */}
            <div class="mt-2 text-sm text-[var(--text-500)]">
              {state.user?.username || ''}
            </div>
          </div>

          {/* Bio Section */}
          <div class="mb-6">
            <div class="bg-[var(--bg-700)] rounded-lg p-4 border border-[var(--bg-600)]">
              <div class="text-[var(--text-400)] text-sm">
                {state.profile?.bio || '这个人很神秘'}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div class="flex flex-col gap-3">
            <Button
              schema="primary"
              onClick={handleEditProfile}
              class="w-full rounded-lg py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
            >
              <Edit size={18} class="mr-2" />
              编辑个人资料
            </Button>

            <Button
              schema="success"
              onClick={handleFeedback}
              class="w-full rounded-lg py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700"
            >
              <MessageSquare size={18} class="mr-2" />
              意见反馈
            </Button>

            <Button
              schema="grey"
              onClick={handleLogout}
              class="w-full rounded-lg py-3 bg-[var(--bg-700)] hover:bg-[var(--bg-600)] text-white"
            >
              <LogOut size={18} class="mr-2" />
              退出
            </Button>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default ProfileCenter








